/*!
* Mondrian Tokens Claro 2.1.2
* Build do dia 10/02/2023 as 10:45:34 GTM-0300 
*
* https://mondrian.claro.com.br
* Copyright (c) 2019 - 2022 Claro <designopsoficial@globalhitss.com.br>
* Todos os direitos reservados.
*
* A redistribuicao ou alteracao sem a permissao dos proprietarios do software e proibida.
*/
export const borderStyleDefault = "solid";
export const borderWidthNone = "0";
export const borderWidthThin = "1px";
export const borderWidthMedium = "2px";
export const borderWidthThick = "4px";
export const borderRadiusNone = "0";
export const borderRadiusXxs = "2px";
export const borderRadiusXs = "4px";
export const borderRadiusSm = "8px";
export const borderRadiusMd = "16px";
export const borderRadiusLg = "24px";
export const borderRadiusPill = "500px";
export const borderRadiusCircle = "50%";
export const colorBrandPrimaryDarkest = "#83170F";
export const colorBrandPrimaryDark = "#B41E13";
export const colorBrandPrimaryMedium = "#DA291C";
export const colorBrandPrimaryLight = "#FC867F";
export const colorBrandPrimaryLightest = "#FFE3E3";
export const colorSupportSuccessLight = "#EDFFCA";
export const colorSupportSuccessDark = "#006B4F";
export const colorSupportDangerLight = "#FFFAAD";
export const colorSupportDangerDark = "#B84D01";
export const colorSupportHighlightDarkest = "#B84D01";
export const colorSupportHighlightDark = "#FB9C2D";
export const colorSupportHighlightLightest = "#FFFAAD";
export const colorSupportHighlightLight = "#FFE458";
export const colorSupportHighlightMedium = "#FFBC4A";
export const colorNeutralLightest = "#FFFFFF";
export const colorNeutralLight = "#F8F8F8";
export const colorNeutralMedium = "#D4D7DE";
export const colorNeutralDark = "#51555D";
export const colorNeutralDarkest = "#000000";
export const opacitySemiOpaque = "0.8";
export const opacityIntense = "0.64";
export const opacityMedium = "0.32";
export const opacityLight = "0.16";
export const opacitySemiTransparent = "0.08";
export const shadowOffsetXNone = "0";
export const shadowOffsetYLevel1 = "4px";
export const shadowOffsetYLevel2 = "4px";
export const shadowOffsetYLevel3 = "16px";
export const shadowOffsetYLevel4 = "16px";
export const shadowBlurRadiusLevel1 = "8px";
export const shadowBlurRadiusLevel2 = "8px";
export const shadowBlurRadiusLevel3 = "24px";
export const shadowBlurRadiusLevel4 = "24px";
export const shadowSpreadRadiusDefault = "-4";
export const shadowSpreadRadiusLight = "-16";
export const spacingInlineXxxs = "4px";
export const spacingInlineXxs = "8px";
export const spacingInlineXs = "16px";
export const spacingInlineSm = "24px";
export const spacingInlineMd = "32px";
export const spacingInlineLg = "48px";
export const spacingInlineXl = "64px";
export const spacingInsetXxs = "4px";
export const spacingInsetXs = "8px";
export const spacingInsetSm = "16px";
export const spacingInsetMd = "24px";
export const spacingInsetLg = "32px";
export const spacingInsetXl = "48px";
export const spacingSquishXxxs = "4px 8px";
export const spacingSquishXxs = "4px 16px";
export const spacingSquishXs = "8px 16px";
export const spacingSquishSm = "8px 24px";
export const spacingSquishMd = "16px 24px";
export const spacingSquishLg = "16px 32px";
export const spacingSquishXl = "24px 32px";
export const spacingSquishXxl = "32px 48px";
export const spacingStackXxxs = "4px";
export const spacingStackXxs = "8px";
export const spacingStackXs = "16px";
export const spacingStackSm = "24px";
export const spacingStackMd = "32px";
export const spacingStackLg = "48px";
export const spacingStackXl = "64px";
export const spacingStackXxl = "96px";
export const spacingStackXxxl = "128px";
export const fontFamilyHighlight = "AMX";
export const fontFamilyBase = "Roboto";
export const fontLineHeightNone = "0";
export const fontLineHeightXxxs = "20px";
export const fontLineHeightXxs = "24px";
export const fontLineHeightXs = "28px";
export const fontLineHeightSm = "32px";
export const fontLineHeightMd = "40px";
export const fontLineHeightLg = "44px";
export const fontLineHeightXl = "48px";
export const fontLineHeightXxl = "64px";
export const fontSizeXxxs = "12px";
export const fontSizeXxs = "16px";
export const fontSizeXs = "20px";
export const fontSizeSm = "24px";
export const fontSizeMd = "28px";
export const fontSizeLg = "32px";
export const fontSizeXl = "36px";
export const fontSizeXxl = "48px";
export const fontWeightLight = "300";
export const fontWeightRegular = "400";
export const fontWeightMedium = "500";
export const fontWeightBold = "700";
export const fontWeightBlack = "800";
export const textUnderline = "underline";
export const textStrike = "line-through";
export const textUppercase = "uppercase";
export const opticalAdjustsXs = "-1";
export const opticalAdjustsSm = "-2";
export const screenSizeXxxs = "360px";
export const screenSizeXxs = "480px";
export const screenSizeXs = "540px";
export const screenSizeSm = "640px";
export const screenSizeMd = "768px";
export const screenSizeLg = "992px";
export const screenSizeXl = "1024px";
export const screenSizeXxl = "1200px";
export const screenSizeXxxl = "1440px";
export const screenSizeUl = "1920px";